import {
  atom,
  selector,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState
} from 'recoil'
import {Account } from '__generated__/graphql'
import { User } from '../models/user.model'

export interface ISiteState {
  key: string
  default: {
    focus?: {
      sf_id: string
    }
    selected: Array<{
      sf_id: string
    }>
  }
}

export const refreshListenersState = atom({
  key: 'refresh-listeners',
  default: {},
  dangerouslyAllowMutability: true
})

const modalState = atom<string | undefined>({
  key: 'modal',
  default: undefined
})

const siteIdState = atom<string | undefined>({
  key: 'siteId',
  default: undefined,
})

const sitesSelectedState = atom({
  key: 'dashboard-sites-selected',
  default: [],
})

export const sitesState = atom({
  key: 'query-sites',
  default: {
    focus: undefined,
    selected: [],
    accounts: [],
    treeRef: null
  } as {focus: undefined|Account, selected: Account[], accounts: Account[], treeRef: unknown},
})

const userState = atom<User | undefined>({
  key: 'user',
  default: undefined,
})

const hasSitesOnProductionState = selector({
  key: 'has-sites-production',
  get: ({get}) => {
    const user = get(userState)
    if (user) {
      return user.accounts.some(({state}) => state?.toLowerCase() === 'en production')
    }
    return false
  }
})

export const ACCOUNTS_LIMIT = 500

const useGetSite = () => {
  return useRecoilValue(siteIdState)
}

const useSetSite = () => {
  return useSetRecoilState(siteIdState)
}

const useSite = () => {
  return useRecoilState(siteIdState)
}

const useUser = () => {
  return useRecoilState(userState)
}

const useDashboardSitesSelected = () => {
  return useRecoilState(sitesSelectedState)
}

const useSites = () => {
  return useRecoilState(sitesState)
}

const useHasSitesOnProduction = () => {
  return useRecoilValue(hasSitesOnProductionState)
}

export const countUserSites = (user: User | undefined): number => {
  if (!user?.accounts) return 0
  return user.accounts.filter(account => account.is_site).length
}
const useModal = () => {
  return useRecoilState(modalState)
}

const useRefreshListeners = () => {
  return useRecoilState(refreshListenersState)
}

export {
  useSites,
  useSite,
  useGetSite,
  useSetSite,
  useUser,
  useDashboardSitesSelected,
  useHasSitesOnProduction,
  useModal,
  useRefreshListeners
}
